import {
  Component,
  ElementRef,
  input,
  output,
  signal,
  ViewChild,
} from "@angular/core";
import { Icon } from "../icon/icon";
import { TranslocoModule } from "@jsverse/transloco";

@Component({
  selector: "app-file-drop-zone",
  imports: [Icon, TranslocoModule],
  templateUrl: "./file-drop-zone.html",
})
export class FileDropZone {
  multiple = input<boolean>(true);
  isDragging = signal(false);
  files = signal<File[]>([]);
  @ViewChild("fileInput") fileInput?: ElementRef<HTMLInputElement>;
  newFile = output<File[]>();
  fileError = output<boolean>();
  openErrorModal = output<void>();

  private readonly MAX_FILE_SIZE = 10 * 1024 * 1024; // 10Mo en bytes

  private filterPdfFiles(fileList: File[]): File[] {
    return fileList.filter(
      (file) =>
        file.type === "application/pdf" ||
        file.name.toLowerCase().endsWith(".pdf")
    );
  }

  private filterFilesBySize(fileList: File[]): File[] {
    const validFiles = fileList.filter(
      (file) => file.size <= this.MAX_FILE_SIZE
    );
    const invalidFiles = fileList.filter(
      (file) => file.size > this.MAX_FILE_SIZE
    );

    if (invalidFiles.length > 0) {
      this.fileError.emit(true);
      this.openErrorModal.emit();
    } else {
      this.fileError.emit(false);
    }

    return validFiles;
  }

  onDragOver(ev: DragEvent) {
    ev.preventDefault();
    this.isDragging.set(true);
  }

  onDragLeave(_ev: DragEvent) {
    this.isDragging.set(false);
  }

  onDrop(ev: DragEvent) {
    ev.preventDefault();
    this.isDragging.set(false);
    const list = ev.dataTransfer?.files;
    if (!list || list.length === 0) return;

    const fileArray = Array.from(list);
    const pdfFiles = this.filterPdfFiles(fileArray);

    if (pdfFiles.length === 0) {
      this.fileError.emit(true);
      this.openErrorModal.emit();
      return;
    }

    const validFiles = this.filterFilesBySize(pdfFiles);

    if (validFiles.length === 0) return;

    const newFiles = this.multiple()
      ? [...this.files(), ...validFiles]
      : [validFiles[0]];
    this.newFile.emit(newFiles);
  }

  openFileDialog() {
    this.fileInput?.nativeElement.click();
  }

  onFileInput(ev: Event) {
    const input = ev.target as HTMLInputElement;
    const list = input.files;
    if (!list) return;

    const fileArray = Array.from(list);
    const validFiles = this.filterFilesBySize(fileArray);

    if (validFiles.length === 0) {
      input.value = "";
      return;
    }

    const newFiles = this.multiple()
      ? [...this.files(), ...validFiles]
      : [validFiles[0]];
    this.newFile.emit(newFiles);
    input.value = "";
  }
}
